import React from 'react';
import cn from 'classnames';
import LitView from '../../../DeviationViews/Dumbo/Literature';
import s from './Literature.scss';
const JournalView = (props)=>{
    const { deviation, width, height } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width: width
        }
    }, /*#__PURE__*/ React.createElement(LitView, {
        width: width,
        height: height,
        deviation: deviation
    }));
};
JournalView.displayName = 'JournalView';
export default JournalView;

//# sourceMappingURL=Literature.js.map